import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';

const MemberOpportunityDesktop = dynamic(
  () => import('./memberOpportunityDesktop')
);
const MemberOpportunityMobile = dynamic(
  () => import('./memberOpportunityMobile')
);
export interface Props {
  setIsRedirecting?: (value: boolean) => void;
}
const MemberOpportunity = ({ setIsRedirecting }: Props) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <MemberOpportunityDesktop setIsRedirecting={setIsRedirecting} />
  ) : (
    <MemberOpportunityMobile setIsRedirecting={setIsRedirecting} />
  );
};

export default MemberOpportunity;
